import { render, staticRenderFns } from "./approveinternalusers.vue?vue&type=template&id=285914bb"
import script from "./approveinternalusers.vue?vue&type=script&lang=js"
export * from "./approveinternalusers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports